import React from 'react';
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import CopyToClipboardUI from '../../../widgets/output/CopyToClipboardUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'

const LeadListUI = ({
  context, leadList, onRowClick,
  onDeleteClick, deleteSubmitted,
  loginSubmitted, selectedLeadId,
  searchFilter, onSearchFilterChange, onCopyToClipboard, copyToClipboardText,
  onLeadUpdateClick,onSendCustomEmailClick,
}) => (
  <div className='su_accs'>
    <div className='g_flex_h g_m_bottom_50'>
      <span>{leadList.length} lead{leadList.length === 1 ? '' : 's'} displayed</span>
    </div>

    <LRTableBodyUI>
      {leadList.map((lead, i) => (
        <AccountRowUI
          key={i} context={context} lead={lead} onRowClick={onRowClick}
          onDeleteClick={onDeleteClick}
          deleteSubmitted={deleteSubmitted}
          loginSubmitted={loginSubmitted}
          selectedLeadId={selectedLeadId}
          onCopyToClipboard={onCopyToClipboard}
          copyToClipboardText={copyToClipboardText}
          onLeadUpdateClick={onLeadUpdateClick}
          onSendCustomEmailClick={onSendCustomEmailClick}
        />
      ))}
    </LRTableBodyUI>
  </div>
);

const AccountRowUI = ({
  context, lead, onRowClick,
  onDeleteClick, deleteSubmitted,
  loginSubmitted, selectedLeadId,
  onCopyToClipboard, copyToClipboardText,
  onLeadUpdateClick, onSendCustomEmailClick
}) => (
  <LRTableRowUI
    className='g_flex_top'
    context={context}
    left={<RowLeftUI context={context} lead={lead}
      onCopyToClipboard={onCopyToClipboard}
      copyToClipboardText={copyToClipboardText}
    />}
    right={<RowRightUI lead={lead} onLeadUpdateClick={onLeadUpdateClick} onSendCustomEmailClick={onSendCustomEmailClick}/>}
  />
);

const RowLeftUI = ({ context, lead, onCopyToClipboard, copyToClipboardText }) => (
  <div className='g_flex_v'>
    <span className='g_flex_h g_muted g_flex_left'>
      <span className='g_m_right_100'>{lead.firstContactDate || 'N/A'}</span>
      <CopyToClipboardUI
        text={lead.leadId}
        onCopyToClipboard={onCopyToClipboard}
        copyToClipboardText={copyToClipboardText}
      />
    </span>
    <div>
      <div><strong>Lead ID:</strong> {lead.leadId}</div>
      <div><strong>Email:</strong> {lead.email}</div>
      <div><strong>Lead Name:</strong> {lead.leadName || 'N/A'}</div>
      <div><strong>First Contact Date:</strong> {lead.firstContactDateF1 || 'N/A'}</div>
      <div><strong>First Contact Method:</strong> {lead.firstContactMethod || 'N/A'}</div>
    </div>
  </div>
);

const ActionLeftUI = ({ context, onRefreshClick, onCreateAccountClick }) => (
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <IconButtonUI icon='icon-plus' onClick={onCreateAccountClick} />
    <span className='g_m_left_100 g_large'><b>Leads</b></span>
  </div>
);

const RowRightUI = ({context, lead, onLeadUpdateClick,onSendCustomEmailClick }) => (
  <div className='g_flex_h'>

     <span className='icon-envelope-o g_m_right_50 g_large ' data-lead-id={lead.leadId}
      onClick={onSendCustomEmailClick}
    />
    <span className='icon icon-pencil' data-lead-id={lead.leadId}
      onClick={onLeadUpdateClick}
    />
  </div>
);


export default LeadListUI
